import Cookies from 'universal-cookie';

/**
 * Get authentication header with access token
 * @returns {Object} Header object with Authorization
 */
export const getAuthHeader = () => {
  const cookies = new Cookies();
  let accessToken = localStorage.getItem('AccessToken');

  if (!accessToken) {
    accessToken = cookies.get('access_token');
  }

  return accessToken ? { authorization: accessToken } : {};
};

/**
 * Get authentication header for multipart form data
 * @returns {Object} Header object with Authorization and Content-Type
 */
export const getAuthHeaderMultipart = () => {
  return {
    'Content-Type': 'multipart/form-data',
    ...getAuthHeader()
  };
};

/**
 * Get authentication header for JSON requests
 * @returns {Object} Header object with Authorization and Content-Type
 */
export const getAuthHeaderJSON = () => {
  return {
    'Content-Type': 'application/json',
    ...getAuthHeader()
  };
};
